

import {
  Button,
  ImageList,
  ImageListItem,
  FormControl,
  RadioGroup,
  FormGroup,
  TextareaAutosize,
  FormControlLabel,
  Checkbox,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { AddOutlined, RemoveOutlined } from "@mui/icons-material";
import Swiper from "./swiper";
import PriceOptionsButtons from "./priceOptionsButtons";
import Dishe from "../sections/dishe";
import i18next, { t } from "i18next";
import calories from "../../../images/Fire.svg";
import time from "../../../images/Timer.svg";
import {
  getBadgeStatusClass,
  getLocalStorageMenuItem,
  ISDARKTHEME,
  SARIconThemeColor,
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileHighlightTextColor,
  setMobileTextColor,
} from "../../../utility";
import { Badge } from "react-bootstrap";
import no_image from "../../../images/No_Image_Available.jpg";
import heart_full_inactive_svg from "../../../images/heart_full_inactive_svg.svg";
import heart_full_inactive_with_white from "../../../images/heart_full_inactive_with_white.svg";
import heart_full_active_svg from "../../../images/heart_full_active_svg.svg";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useEffect, useState } from "react";
import CheckModifier from "./checkModifier";
import CheckModifiers from "./checkModifiers";
import LoadingTreeDataDialog from "../mobileComponents/LoadingTreeDataDialog";

const MianInfo = ({
  item,
  sympoleData,
  selected,
  calorie,
  tableQr,
  tableName,
  updataItem,
  favorites,
  handleFavorite,
  handleSelected,
  open,
  handleOrder,
  order_ability,
  treeData,
  handleOpenToast,
  not_menu_availability,
  isDesktop,
  isTablet
}) => {
  const [params, setParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const onImageError = (e) => {
    e.target.src = no_image;
  };

  const [checked, setChecked] = useState(false);
  const [qty, setQty] = useState(1);
  const queryClient = useQueryClient();
  const [loadingTreeDialog, setLoadingTreeDialog] = useState(false);

  useEffect(() => {
    if (item?.modifiers && item?.modifiers?.length > 0)
      handleOpenToast(t("This item contains options, please make sure you have selected the required ones"), true);
  }, [])

  const addItemFuction = async (values) => {
    const itemData = treeData?.items?.find((item) => item.id === Number(values.item_id));
    const selectedOrderType = getLocalStorageMenuItem("orderType");

    if (selectedOrderType === "delivery" && !itemData?.is_delivery_on) {
      return { success_add: false, type: "delivery" }
    }

    if (selectedOrderType === "pickup" && !itemData?.is_pickup_on) {
      return { success_add: false, type: "pickup" }
    }

    if (selectedOrderType === "dinein" && !itemData?.is_dinein_on) {
      return { success_add: false, type: "dinein" }
    }

    const { data: response } = await axios.post(
      `${process.env.REACT_APP_API}/basket-items`,
      values,
      {
        headers: {
          localization: getLocalStorageMenuItem("lang"),
        },
      }
    );

    return { ...response, itemData };
  };

  const { mutate, isLoading, isSuccess } = useMutation(addItemFuction, {
    onSuccess: (res) => {
      if (res && res?.hasOwnProperty('success_add') && !res?.success_add) {
        handleOpenToast(t("sorry!, this item isn't available for the order type") + " " + t(`${res?.type}`), false);
      } else {
        handleOpenToast(t("Order has been added successfully"), true);
        if (!checked) {
          setTimeout(() => {
            navigate(
              `/${tableName}/${tableQr}/sections?section=${params.get("section") ? params.get("section") : '0'}&t=${params.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
              , {
                replace: true
              });
          }, 1000);
        }
        setQty(1);
        queryClient.invalidateQueries(["basket-items", getLocalStorageMenuItem("lang")]);
      }
    },
    onError: (res) => {
      handleOpenToast(t(res.response.data.message), false);
    },
    onSettled: () => {
      queryClient.invalidateQueries("addToBasket");
    },
  });

  const openItem = (comboItem) => {
    if (item.sold_out !== 1) {
      if (location.pathname === `/${tableName}/${tableQr}/sections`) {
        navigate(
          `/${tableName}/${tableQr}/items?item=${comboItem?.id}&t=${params.get(
            "t"
          )}&selectedLang=${getLocalStorageMenuItem("lang")}`,
          {
            replace: true,
            state: { from: location.pathname },
          }
        );
      } else {
        updataItem(comboItem);
      }
    }
  };

  const customRadioStyles = {
    "& .MuiRadio-root": {
      color:
        getLocalStorageMenuItem("theme") === "dark" ||
          getLocalStorageMenuItem("theme") === "white"
          ? "#6BA5F2"
          : setMobileButttonBackColor(),
    },
  };

  const customCheckStyles = {
    color:
      getLocalStorageMenuItem("theme") === "dark" ||
        getLocalStorageMenuItem("theme") === "white"
        ? "#6BA5F2"
        : setMobileButttonBackColor(),
  };

  const modifiers =
    item?.modifiers?.filter((element) => {
      return element?.order_options.length > 0;
    }) || [];

  return (
    <div style={{
      paddingBottom: isDesktop || isTablet ? '0' : '75px',
      height: isDesktop || isTablet ? 'auto' : 'auto'
    }}>
      <LoadingTreeDataDialog
        openTreeDialogFlag={loadingTreeDialog}
        onClose={() => setLoadingTreeDialog(false)}
        tableName={tableName}
        tableQr={tableQr}
        from_home={false}
      />
      <Formik
        initialValues={{
          table: params.get("t"),
          item_id: item?.id,
          modifiers: modifiers.map((element) => {
            return {
              id: element.group.id,
              max: element.max,
              min: element.min,
              order_options: [],
            };
          }),
          price_option: selected ? selected.id : null,
          quantity: 1,
          notes: "",
          menu_code: tableQr,
          price: selected ? selected.price : item?.price,
          token: getLocalStorageMenuItem("gustToken"),
          prevOptionPrice: 0,
        }}
        enableReinitialize
        onSubmit={(values) => {
          if (not_menu_availability) {
            setLoadingTreeDialog(true);
          } else {
            mutate(values);
          }
        }}
      >
        {({ errors, setFieldValue, values, resetForm }) => (
          <Form className="min-vh-75">
            {/* Header Section */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: isDesktop || isTablet ? '20px 24px' : '12px'
              }}
              className="head alignByLang"
            >
              {item.label_name ? (
                <p className="mb-2 alignByLang">
                  <Badge
                    className={`${getBadgeStatusClass(item.label_name)} p-2 font-size-12 sub-font m-1`}
                    style={{ fontSize: isDesktop ? '14px' : '12px' }}
                  >
                    {item.label_name || "New"}
                  </Badge>
                  {item?.sold_out !== 1 ? (
                    <Badge
                      className={`${getLocalStorageMenuItem("theme") === "dark"
                        ? "instock-badge-style-dark"
                        : "instock-badge-style"
                        } p-2 font-size-12 sub-font m-1`}
                      style={{ fontSize: isDesktop ? '14px' : '12px' }}
                    >
                      {t("in stock")}
                    </Badge>
                  ) : (
                    <Badge
                      className={`${getLocalStorageMenuItem("theme") === "dark"
                        ? "outofinstock-badge-style-dark"
                        : "outofinstock-badge-style"
                        } p-2 font-size-12 sub-font m-1`}
                      style={{ fontSize: isDesktop ? '14px' : '12px' }}
                    >
                      {t("Out of stock")}
                    </Badge>
                  )}
                </p>
              ) : (
                <p className="mb-2 alignByLang">
                  <Badge
                    className={`${getBadgeStatusClass("New")} p-2 font-size-12 sub-font m-1`}
                    style={{ fontSize: isDesktop ? '14px' : '12px' }}
                  >
                    {t("New")}
                  </Badge>
                  {item?.sold_out !== 1 ? (
                    <Badge
                      className={`${getLocalStorageMenuItem("theme") === "dark"
                        ? "instock-badge-style-dark"
                        : "instock-badge-style"
                        } p-2 font-size-12 sub-font m-1`}
                      style={{ fontSize: isDesktop ? '14px' : '12px' }}
                    >
                      {t("in stock")}
                    </Badge>
                  ) : (
                    <Badge
                      className={`${getLocalStorageMenuItem("theme") === "dark"
                        ? "outofinstock-badge-style-dark"
                        : "outofinstock-badge-style"
                        } p-2 font-size-12 sub-font m-1`}
                      style={{ fontSize: isDesktop ? '14px' : '12px' }}
                    >
                      {t("Out of stock")}
                    </Badge>
                  )}
                </p>
              )}

              {!(isDesktop || isTablet) && (
                <span className="heart cursor" style={{ justifyContent: "center", alignSelf: "center" }} onClick={() => handleFavorite(item)}>
                  {favorites.findIndex((fav) => fav.id === item?.id) !== -1 ? (
                    <img
                      src={heart_full_active_svg}
                      className="heart"
                      style={{ width: "45px", height: "35px" }}
                      onError={onImageError}
                    />
                  ) : (
                    <img
                      src={ISDARKTHEME(getLocalStorageMenuItem("theme") || treeData?.details?.mobile_settings?.theme, setMobileBackColor() || treeData?.details?.mobile_settings?.colorProps?.back) ? heart_full_inactive_with_white : heart_full_inactive_svg}
                      className="heart"
                      style={{ width: "45px", height: "35px" }}
                      onError={onImageError}
                    />
                  )}
                </span>
              )}
            </div>

            {/* Title and Price Section */}
            {item?.has_price_option_item && item?.price_option_items?.length ? (
              <div className="alignByLang" style={{ padding: isDesktop || isTablet ? '0 24px' : '0 12px' }}>
                <p
                  className="fw-bold mt-3 head-font"
                  style={{
                    textAlign:
                      getLocalStorageMenuItem("lang") === "ar" ||
                        getLocalStorageMenuItem("lang") === "fa"
                        ? "right"
                        : "left",
                    fontSize: isDesktop ? '26px' : isTablet ? '22px' : '22px'
                  }}
                >
                  {item?.name}
                </p>
                <PriceOptionsButtons
                  handleSelected={async (selectedOption) => {
                    await handleSelected(selectedOption);
                    setFieldValue("price_option", selectedOption.id);
                    setFieldValue("price", selectedOption.price);
                  }}
                  prices={item?.price_option_items}
                  currency={sympoleData}
                  isDesktop={isDesktop}
                  isTablet={isTablet}
                />
              </div>
            ) : item?.price_options?.length > 0 ? (
              <div className="alignByLang" style={{ padding: isDesktop || isTablet ? '0 24px' : '0 12px' }}>
                <p
                  className="fw-bold mt-3 head-font"
                  style={{
                    textAlign:
                      getLocalStorageMenuItem("lang") === "ar" ||
                        getLocalStorageMenuItem("lang") === "fa"
                        ? "right"
                        : "left",
                    fontSize: isDesktop ? '26px' : isTablet ? '22px' : '22px'
                  }}
                >
                  {item?.name}
                </p>
                <PriceOptionsButtons
                  handleSelected={async (selectedOption) => {
                    await handleSelected(selectedOption);
                    setFieldValue("price_option", selectedOption.id);
                    setFieldValue("price", selectedOption.price);
                  }}
                  prices={item?.price_options}
                  currency={sympoleData}
                  isDesktop={isDesktop}
                  isTablet={isTablet}
                />
              </div>
            ) : (
              <div
                className="d-flex justify-content-between alignByLang"
                style={{ padding: isDesktop || isTablet ? '0 24px' : '0 12px' }}
              >
                <p
                  style={{ color: setMobileTextColor(), maxWidth: "70%", fontSize: isDesktop ? '26px' : isTablet ? '22px' : '22px' }}
                  className="head-font"
                >
                  {item?.name}
                </p>

                <p
                  className="head-font"
                  style={{
                    color:
                      getLocalStorageMenuItem("theme") === "costomize"
                        ? setMobileTextColor()
                        : "#6ba5f2",
                    fontSize: isDesktop ? '24px' : isTablet ? '20px' : '18px'
                  }}
                >
                  <span>
                    {item?.old_price > 0 && (
                      <span
                        style={{
                          textDecoration: "line-through",
                          color: "red",
                        }}
                      >
                        {item.old_price || ""}
                      </span>
                    )}{" "}
                    {item?.price}{" "}
                    {sympoleData ? (
                      sympoleData === "SAR" ? (
                        <img
                          width={isDesktop ? 24 : 20}
                          height={isDesktop ? 24 : 20}
                          src={SARIconThemeColor()}
                          className="mr-1"
                        />
                      ) : (
                        sympoleData
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </p>
              </div>
            )}

            {/* Contents Section */}
            <div className="contents alignByLang" style={{ padding: isDesktop || isTablet ? '16px 24px' : '12px' }}>
              {item?.price_options?.length > 0 && calorie && calorie > 0 ? (
                <span
                  className="fw-bold sub-font mr-1"
                  style={{ color: setMobileTextColor(), fontSize: isDesktop ? '16px' : '14px' }}
                >
                  <img src={calories} className="mr-1 calories_style" style={{ width: isDesktop ? '24px' : '20px' }} />{" "}
                  {`${calorie ? calorie : 0} ${t("cal")}`}
                </span>
              ) : (
                item?.calories &&
                item?.calories > 0 &&
                item?.price_options?.length === 0 && (
                  <span className="head-font" style={{ fontSize: isDesktop ? '16px' : '14px' }}>
                    <img src={calories} className="mr-1 calories_style" style={{ width: isDesktop ? '24px' : '20px' }} />{" "}
                    {`${item?.calories ? item?.calories : 0} ${t("cal")}`}
                  </span>
                )
              )}

              <span
                className="head-font mr-1"
                style={{ color: setMobileTextColor(), fontSize: isDesktop ? '16px' : '14px' }}
              >
                {(item?.max_preparation_time != null &&
                  item?.max_preparation_time >= 0) ||
                  (item?.min_preparation_time != null &&
                    item?.min_preparation_time >= 0) ? (
                  <img src={time} className="mr-1 timer_style" style={{ width: isDesktop ? '24px' : '20px' }} />
                ) : (
                  ""
                )}

                {` ${item?.min_preparation_time === 0
                  ? item?.min_preparation_time
                  : !item?.min_preparation_time
                    ? ""
                    : item?.min_preparation_time
                  } ${(!item?.max_preparation_time && item?.max_preparation_time !== 0) ||
                    (!item?.min_preparation_time && item?.min_preparation_time !== 0)
                    ? ``
                    : `-`
                  }    ${item?.max_preparation_time === 0
                    ? item?.max_preparation_time
                    : !item?.max_preparation_time
                      ? ""
                      : item?.max_preparation_time
                  }
              
              ${(item?.max_preparation_time != null &&
                    item?.max_preparation_time >= 0) ||
                    (item?.min_preparation_time != null &&
                      item?.min_preparation_time >= 0)
                    ? t("min(s)") + " "
                    : ""
                  }
              `}
              </span>

              {/* Description */}
              {item?.description && (
                <div className="mt-4">
                  <p
                    style={{ color: setMobileTextColor(), fontSize: isDesktop ? '18px' : '16px' }}
                    className="head-font mb-2"
                  >
                    {t("Description")}
                  </p>
                  <p
                    style={{
                      color: setMobileTextColor(),
                      fontWeight: 400,
                      fontSize: isDesktop ? '15px' : '12px',
                      lineHeight: isDesktop ? '1.6' : '1.5'
                    }}
                    className="sub-font"
                  >
                    {item?.description}
                  </p>
                </div>
              )}

              {/* Warnings */}
              <div className="mt-4">
                {item?.warnings?.length > 1 && (
                  <p
                    style={{ color: setMobileTextColor(), fontSize: isDesktop ? '18px' : '16px' }}
                    className="head-font mb-2"
                  >
                    {t("warning ingredient")}
                  </p>
                )}
                <div className="col-12">
                  {item?.warnings?.map((element) => (
                    <span key={element.id} className="alignByLang">
                      <span
                        style={{
                          marginLeft: 2,
                          marginRight: 5,
                          fontSize: isDesktop ? '16px' : '14px'
                        }}
                        className="sub-font"
                      >
                        <img
                          style={{
                            width: isDesktop ? "36px" : "32px",
                            height: isDesktop ? "36px" : "32px",
                            marginLeft: 2,
                            marginRight: 5,
                          }}
                          src={ISDARKTHEME(getLocalStorageMenuItem("theme") || treeData?.details?.mobile_settings?.theme, setMobileBackColor() || treeData?.details?.mobile_settings?.colorProps?.back) ? element.icon_dark : element?.icon_light || element.icon}
                          onError={onImageError}
                          alt="icon"
                        />
                        {element.name}
                      </span>
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Modifiers Section */}
            {modifiers?.map((modifier) => (
              <div
                key={modifier.group.id}
                className="m-top-12 alignByLang"
                style={{ padding: isDesktop || isTablet ? '12px 24px' : '12px' }}
              >
                <div className="d-flex justify-content-between">
                  <p
                    className="head-font"
                    style={{
                      color: setMobileTextColor(),
                      fontSize: isDesktop ? '18px' : '16px'
                    }}
                  >
                    {modifier.group.name}{" "}
                    <span
                      className="sub-font"
                      style={{
                        color: setMobileTextColor(),
                        fontSize: isDesktop ? '16px' : '14px'
                      }}
                    >
                      {modifier.required === 1
                        ? `(${t("Choose 1")})`
                        : `(${t("Choose")} ${modifier.min} ${t("to")} ${modifier.max})`}
                    </span>
                  </p>
                  {modifier.required === 1 && (
                    <div>
                      <Button
                        variant="outlined"
                        className="head-font new-badge-style"
                        sx={{
                          borderColor: setMobileButttonBackColor(),
                          color: setMobileTextColor(),
                          fontSize: isDesktop ? '14px' : '12px',
                          padding: isDesktop ? '8px 16px' : '6px 12px'
                        }}
                      >
                        {t("Require")}
                      </Button>
                    </div>
                  )}
                </div>
                {modifier.required === 1 ? (
                  <FormControl className="d-block">
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      className="d-block"
                      onClick={(e) => {
                        if (e.target.value) {
                          const array = [...values.modifiers];
                          const index = array.findIndex(
                            (element) => element.id === modifier.group.id
                          );
                          if (index === -1) {
                            const newModifier = {
                              id: modifier.group.id,
                              min: modifier.min,
                              max: modifier.max,
                              order_options: [JSON.parse(e.target.value).id],
                            };
                            array.push(newModifier);
                            setFieldValue("modifiers", array);
                            setFieldValue(
                              "price",
                              values.price + JSON.parse(e.target.value).price
                            );
                            setFieldValue(
                              "prevOptionPrice",
                              JSON.parse(e.target.value).price
                            );
                          } else {
                            const newModifier = { ...array[index] };
                            newModifier.order_options = [
                              JSON.parse(e.target.value).id,
                            ];
                            array[index] = newModifier;
                            setFieldValue("modifiers", array);
                            setFieldValue(
                              "price",
                              values.price +
                              JSON.parse(e.target.value).price -
                              values.prevOptionPrice
                            );
                            setFieldValue(
                              "prevOptionPrice",
                              JSON.parse(e.target.value).price
                            );
                          }
                        }
                      }}
                      sx={customRadioStyles}
                    >
                      <div className="sub-font">
                        {modifier?.order_options.map((element) => (
                          <CheckModifier
                            key={element.id}
                            order={element}
                            currency={sympoleData}
                            setFieldValue={setFieldValue}
                            values={values}
                            modifier={modifier}
                            handleOpenToast={handleOpenToast}
                          />
                        ))}
                      </div>
                    </RadioGroup>
                  </FormControl>
                ) : (
                  <FormGroup>
                    <div className="sub-font">
                      {modifier?.order_options.map((element) => (
                        <CheckModifiers
                          key={element.id}
                          order={element}
                          currency={sympoleData}
                          setFieldValue={setFieldValue}
                          values={values}
                          modifier={modifier}
                          handleOpenToast={handleOpenToast}
                        />
                      ))}
                    </div>
                  </FormGroup>
                )}
              </div>
            ))}

            {/* Notes Section */}
            <div
              className="m-top-12 alignByLang"
              style={{
                marginBottom: isDesktop || isTablet ? "24px" : "0px",
                padding: isDesktop || isTablet ? '12px 24px' : '12px'
              }}
            >
              <label
                htmlFor="notes"
                className="sub-font mb-1"
                onClick={resetForm}
                style={{
                  color: setMobileTextColor(),
                  fontSize: isDesktop ? '16px' : '14px'
                }}
              >
                {t("Note")}
              </label>
              <TextareaAutosize
                id="notes"
                name="notes"
                minRows={isDesktop ? 4 : 3}
                className="form-control rounded-2 sub-font"
                style={{
                  resize: "none",
                  backgroundColor: setMobileBackColor(),
                  color: setMobileTextColor(),
                  fontSize: isDesktop ? '15px' : '14px',
                  padding: isDesktop ? '12px' : '8px'
                }}
                value={values.notes}
                onChange={(e) => setFieldValue("notes", e.target.value)}
                placeholder={t("Enter a note...")}
                inputprops={{
                  style: {
                    color: setMobileTextColor(),
                    backgroundColor: setMobileBackColor(),
                  },
                }}
              />
              <FormControlLabel
                control={<Checkbox style={customCheckStyles} />}
                className="mx-0 mt-2"
                label={
                  <span
                    className="sub-font"
                    style={{
                      color: setMobileTextColor(),
                      fontSize: isDesktop ? '16px' : '14px'
                    }}
                  >
                    {t("Add and continue")}
                  </span>
                }
                onChange={(e) => setChecked(e.target.checked)}
              />
            </div>

            {/* Combo Items */}
            {item?.is_combo_item && item?.comboItems?.length > 0 && (
              <div
                className="mt-4 sub-font"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: isDesktop || isTablet ? '0 24px' : '0 12px'
                }}
              >
                <h2
                  className="sub-font"
                  style={{
                    marginBottom: '2px',
                    fontSize: isDesktop ? '1.3rem' : '1rem',
                    color: setMobileCardBorderColor(),
                    textAlign: 'center'
                  }}
                >
                  {t("Combo Items")}
                </h2>

                <div
                  style={{
                    display: 'table',
                    width: '90%',
                    margin: '10px auto',
                    textAlign: 'center',
                  }}
                >
                  {item?.comboItems?.map((comboItem, index) => (
                    <div
                      className="sub-font alignByLang"
                      key={index}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        backgroundColor: setMobileCardBorderColor(),
                        marginBottom: '10px',
                        padding: isDesktop ? '10px' : '5px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease',
                      }}
                      onClick={() => openItem(comboItem)}
                      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    >
                      <div
                        style={{
                          width: isDesktop ? '100px' : '80px',
                          flexShrink: 0,
                        }}
                      >
                        <img
                          src={comboItem?.image || no_image}
                          alt={t(item?.name)}
                          style={{
                            width: isDesktop ? '70px' : '50px',
                            height: isDesktop ? '70px' : '50px',
                            objectFit: 'cover',
                            borderRadius: '5px'
                          }}
                          onError={onImageError}
                        />
                      </div>
                      <div style={{ flex: 1, textAlign: 'center' }}>
                        <span
                          className="sub-font"
                          style={{
                            color: setMobileTextColor(),
                            fontSize: isDesktop ? '16px' : '14px'
                          }}
                        >
                          {t(comboItem?.name)}
                        </span>
                      </div>
                      <div style={{ flex: 1, textAlign: 'center' }}>
                        <span
                          style={{
                            color: setMobileTextColor(),
                            fontSize: isDesktop ? '16px' : '14px'
                          }}
                        >
                          {comboItem?.quantity}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Suggested Items */}
            {item?.recommended_items?.length > 0 && (
              <div
                className={`footer  p-4 w-100 alignByLang ${getLocalStorageMenuItem("mode") === "dark"
                  ? "footer-dark"
                  : "footer-light"
                  }`}
                style={{
                  color: setMobileTextColor(),
                  marginBottom: isDesktop || isTablet ? "24px" : "62px",
                  borderBottom: "0px",
                  borderLeft: "0px",
                  borderRight: "0px",
                  padding: isDesktop || isTablet ? '24px' : '12px'
                }}
              >
                <div className="row">
                  <h2
                    style={{
                      color: setMobileTextColor(),
                      fontSize: isDesktop ? '24px' : '20px'
                    }}
                    className="head-font"
                  >
                    <strong>{t("Suggested items")}</strong>
                  </h2>
                  <ImageList
                    sx={{
                      gridAutoFlow: "column",
                      gridTemplateColumns: isDesktop
                        ? "repeat(auto-fill,minmax(200px,1fr)) !important"
                        : "repeat(auto-fill,minmax(160px,1fr)) !important",
                      gridAutoColumns: isDesktop ? "minmax(200px, 1fr)" : "minmax(160px, 1fr)",
                    }}
                  >
                    {item?.recommended_items.map(
                      (element) =>
                        item?.id !== element.id && (
                          <ImageListItem
                            className="me-3"
                            key={element.id}
                            interval={3000}
                          >
                            <Dishe
                              item={element}
                              updataItem={updataItem}
                              qrCode={tableQr}
                              qrName={tableName}
                              favorites={favorites}
                              sympole={sympoleData}
                              handleFavorite={handleFavorite}
                              suggested={true}
                              isDesktop={isDesktop}
                            />
                          </ImageListItem>
                        )
                    )}
                  </ImageList>
                </div>
              </div>
            )}

            {!(isDesktop || isTablet) ? (
              <div
                className="add-cart-button-containter"
                style={{
                  backgroundColor: setMobileBackColor(),
                  padding: 15,
                  position: 'fixed',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  zIndex: 1000,
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  gap={0.5}
                  sx={{
                    backgroundColor: "rgba(255,255,255,0.08)",
                    borderRadius: 2,
                    px: 0.3,
                    py: 0.1,
                    mx: 1,
                  }}
                >
                  <IconButton
                    onClick={() => {
                      const newQty = qty - 1;
                      if (newQty > 0) {
                        setQty(newQty);
                        setFieldValue("quantity", newQty);
                      }
                    }}
                    size="small"
                    sx={{
                      backgroundColor: setMobileButttonBackColor(),
                      color: setMobileTextColor(),
                      "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
                    }}
                    disabled={qty <= 1}
                  >
                    <RemoveOutlined sx={{ color: setMobileHighlightTextColor() || setMobileTextColor()}} fontSize="small" />
                  </IconButton>

                  <Typography
                    variant="body1"
                    sx={{
                      color: setMobileTextColor(),
                      fontWeight: 600,
                      minWidth: 32,
                      textAlign: "center",
                    }}
                  >
                    {qty}
                  </Typography>

                  <IconButton
                    onClick={() => {
                      const newQty = qty + 1;
                      setQty(newQty);
                      setFieldValue("quantity", newQty);
                    }}
                    size="small"
                    sx={{
                      backgroundColor: setMobileButttonBackColor(),
                      color: setMobileHighlightTextColor() || setMobileTextColor(),
                      "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
                    }}
                  >
                    <AddOutlined fontSize="small" />
                  </IconButton>
                </Box>
                {!treeData?.details?.order_ability && !treeData?.details?.whatsapp ? (
                  true
                ) : (
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    sx={{
                      backgroundColor: setMobileButttonBackColor(),
                      borderRadius: 3,
                      p: 1,
                      width: "90%",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    }}
                  >
                    <Button
                      className="head-font"
                      variant="contained"
                      disableElevation
                      sx={{
                        flex: 1,
                        backgroundColor: setMobileButttonBackColor(),
                        color: setMobileHighlightTextColor() || setMobileTextColor(),
                        fontSize: "0.95rem",
                        fontWeight: 600,
                        borderRadius: 2,
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.15)",
                        },
                      }}
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading ? t("Loading...") : t("Add to cart")}
                    </Button>
                  </Box>
                )}
              </div>
            ) :

              (
                <Box
                  sx={{
                    width: '100%',
                    padding: '20px 0',
                    backgroundColor: setMobileBackColor(),
                  }}
                >
                  {/* Quantity Selector */}
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    gap={2}
                    sx={{
                      backgroundColor: "rgba(255,255,255,0.08)",
                      borderRadius: 3,
                      py: 1.5,
                      px: 2,
                      mb: 3,
                    }}
                  >
                    <IconButton
                      onClick={() => {
                        if (qty > 1) {
                          setQty(qty - 1);
                        }
                      }}
                      size={isDesktop ? "medium" : "small"}
                      sx={{
                        backgroundColor: setMobileButttonBackColor(),
                        color: setMobileTextColor(),
                        "&:hover": {
                          backgroundColor: setMobileButttonBackColor(),
                          opacity: 0.8
                        },
                        width: isDesktop ? '40px' : '36px',
                        height: isDesktop ? '40px' : '36px',
                      }}
                      disabled={qty <= 1}
                    >
                      <RemoveOutlined
                        sx={{ color: setMobileTextColor() }}
                        fontSize={isDesktop ? "medium" : "small"}
                      />
                    </IconButton>

                    <Typography
                      variant="h6"
                      sx={{
                        color: setMobileTextColor(),
                        fontWeight: 700,
                        minWidth: 50,
                        textAlign: "center",
                        fontSize: isDesktop ? '22px' : '18px',
                      }}
                    >
                      {qty}
                    </Typography>

                    <IconButton
                      onClick={() => {
                        setQty(qty + 1);
                      }}
                      size={isDesktop ? "medium" : "small"}
                      sx={{
                        backgroundColor: setMobileButttonBackColor(),
                        color: setMobileTextColor(),
                        "&:hover": {
                          backgroundColor: setMobileButttonBackColor(),
                          opacity: 0.8
                        },
                        width: isDesktop ? '40px' : '36px',
                        height: isDesktop ? '40px' : '36px',
                      }}
                    >
                      <AddOutlined
                        sx={{ color: setMobileTextColor() }}
                        fontSize={isDesktop ? "medium" : "small"}
                      />
                    </IconButton>
                  </Box>

                  {/* Total Price Display */}
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 3,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: setMobileTextColor(),
                        opacity: 0.7,
                        fontSize: isDesktop ? '14px' : '12px',
                        mb: 0.5,
                      }}
                    >
                      {t("Total Price")}
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{
                        color: setMobileTextColor(),
                        fontWeight: 700,
                        fontSize: isDesktop ? '28px' : '24px',
                      }}
                    >
                      {((selected?.price || item?.price || 0) * qty).toFixed(2)} {sympoleData}
                    </Typography>
                  </Box>

                  <Button
                    className="head-font"
                    variant="contained"
                    fullWidth
                    disableElevation
                    sx={{
                      backgroundColor: setMobileButttonBackColor(),
                      color: setMobileTextColor(),
                      fontSize: isDesktop ? '18px' : '16px',
                      fontWeight: 700,
                      borderRadius: 3,
                      py: isDesktop ? 2 : 1.5,
                      textTransform: "none",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: setMobileButttonBackColor(),
                        opacity: 0.9,
                        transform: "translateY(-2px)",
                        boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
                      },
                      "&:active": {
                        transform: "translateY(0)",
                      },
                    }}
                    type="submit"
                  >
                    {t("Add to cart")}
                  </Button>

                  {/* Additional Info */}
                  {item?.modifiers && item?.modifiers?.length > 0 && (
                    <Typography
                      variant="caption"
                      sx={{
                        display: 'block',
                        textAlign: 'center',
                        color: setMobileTextColor(),
                        opacity: 0.6,
                        mt: 2,
                        fontSize: isDesktop ? '13px' : '11px',
                      }}
                    >
                      {t("Make sure you have selected the required options")}
                    </Typography>
                  )}
                </Box>
              )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default MianInfo;